import React from 'react';
import { Embedded, EmptyState } from 'components';
import { ReactComponent as NotFound } from 'svgs/not_found.svg';

const NotFoundScreen = () => {
	return (
		<EmptyState
			heading="Page Not Found"
			Illustration={NotFound}
			action={{
				text: 'Go to Dashboard',
				url: '/',
			}}
		>
			<p>Oh no! We could not find the page you were looking for.</p>
		</EmptyState>
	);
};

export default NotFoundScreen;
